import React, { Component } from 'react';
import Modal from 'react-modal';

import Analytics from 'APP_ROOT/services/analytics';

import EditPlanSection from './editPlanSection';
import CancelPlanSection from './cancelPlanSection';
import ConfirmPlanSection from './confirmPlanSection';

export default class EditPlanModal extends Component {

    constructor(props) {

        super(props);

        this.state = {
            successMessage: null,
            cancelPlan: false,
            confirmPlan: false,
        };
    }

    afterEditPlanModalOpened = (e) => {
        Analytics.modalView('/editPlanModal');
        this.setState({
            successMessage: null,
            cancelPlan: false,
            confirmPlan: false,
            duplicateTargetPlan: false
        })
    }

    onCancelPlanClick = (e) => {

        e.preventDefault();
        this.setState({
            cancelPlan: true
        })
    }

    onConfirmPlanClick = (e) => {

        e.preventDefault();
        var nextPlan = undefined;
        if (this.props.accountDetails) {
            nextPlan = this.props.accountDetails.subscriptions.find(plan => {
                return plan.state === "pending" && plan.subscriptionUuid === this.props.subscription.subscriptionUuid
            })
        }
        if ((this.props.subscription && this.props.subscription.state === 'canceled') ||
            (this.props.subscription && this.props.subscription.planCode !== this.state.targetPlanCode) ||
            (!this.props.subscription) ||
            (this.props.subscription && nextPlan && nextPlan.planCode !== this.props.subscription.planCode)) {
            this.setState({
                confirmPlan: true
            })
        } else {
            this.setState({
                duplicateTargetPlan: true
            })
        }
    }

    saveRecurlyPricing = (e, planCode) => {

        this.setState({
            recurlyPricing: e,
            targetPlanCode: planCode,
            duplicateTargetPlan: false
        })
    }

    goBack = (e) => {

        e.preventDefault();
        this.setState({
            successMessage: null,
            cancelPlan: false,
            confirmPlan: false,
            duplicateTargetPlan: false
        })
    }

    render() {

        if (!this.props.raven.canEdit) return null;

        var section = <EditPlanSection {...this.props} {...this.state}
            onCancelPlanClick={this.onCancelPlanClick}
            onConfirmPlanClick={this.onConfirmPlanClick}
            recurlyPricing={this.state.recurlyPricing}
            targetPlanCode={this.state.targetPlanCode}
            saveRecurlyPricing={this.saveRecurlyPricing} />;
        if (this.state.cancelPlan) {
            section = <CancelPlanSection {...this.props}
                goBack={this.goBack}
            />
        }
        if (this.state.confirmPlan) {
            section = <ConfirmPlanSection {...this.props} {...this.state}
                recurlyPricing={this.state.recurlyPricing}
                targetPlanCode={this.state.targetPlanCode}
                submitServicePlan={this.submitServicePlan}
                goBack={this.goBack}
            />
        }
        return (
            <Modal isOpen={this.props.editPlanModalOpen}
                contentLabel="edit-plan-modal"
                className="react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onRequestClose={this.props.closeEditPlanModal}
                onAfterOpen={this.afterEditPlanModalOpened}>

                <div className="container-fluid form-card">
                    <div className="row">
                        {section}
                    </div>
                </div>
            </Modal>
        );
    }
}
